"use client";

import { AnimatePresence, motion } from "framer-motion";
import { ArrowLeftCircle, ArrowRightCircle } from "lucide-react";
import { useEffect, useState } from "react";

export default function HowItWorks() {
	const [text, setText] = useState("");
	const [direction, setDirection] = useState("left");
	const [color, setColor] = useState("text-blue-400");

	useEffect(() => {
		const phrases = [
			{
				text: "Hey, how's it going?",
				direction: "left",
				color: "text-blue-400",
			},
			{
				text: "I'm doing great, thanks!",
				direction: "right",
				color: "text-green-400",
			},
			{
				text: "Did you hear about the new restaurant?",
				direction: "left",
				color: "text-blue-400",
			},
			{
				text: "No, tell me more!",
				direction: "right",
				color: "text-green-400",
			},
		];

		let index = 0;
		const intervalId = setInterval(() => {
			if (index < phrases.length) {
				const { text, direction, color } = phrases[index];
				setText(text);
				setDirection(direction);
				setColor(color);
				index++;
			} else {
				index = 0;
			}
		}, 3000);

		return () => clearInterval(intervalId);
	}, []);

	return (
		<section className="relative flex h-screen flex-col items-center justify-center">
			<h2 className="mb-12 text-3xl font-light uppercase tracking-wider lg:mb-16 lg:text-4xl">
				How It Works
			</h2>
			<div className="relative flex aspect-video w-full items-center justify-center">
				<AnimatePresence mode="wait">
					<motion.div
						key={text}
						className={`absolute flex items-center gap-2 lg:gap-4 ${
							direction === "left" ? "left-4" : "right-4"
						} top-1/2 max-w-[45%] -translate-y-1/2 transform`}
						initial={{ opacity: 0, x: direction === "left" ? -20 : 20 }}
						animate={{ opacity: 1, x: 0 }}
						exit={{ opacity: 0, x: direction === "left" ? 20 : -20 }}
						transition={{ duration: 0.3 }}
					>
						{direction === "left" && (
							<ArrowLeftCircle className={`h-4 w-4 lg:h-6 lg:w-6 ${color}`} />
						)}
						<p
							className={`text-base font-light tracking-wide lg:text-2xl ${color} text-center`}
						>
							{text}
						</p>
						{direction === "right" && (
							<ArrowRightCircle className={`h-4 w-4 lg:h-6 lg:w-6 ${color}`} />
						)}
					</motion.div>
				</AnimatePresence>
			</div>
		</section>
	);
}
